<div class="owner-change-container" (click)="$event.stopPropagation()">
  <ngx-users-search
    [hideCheckbox]="true"
    [hideHeader]="true"
    [selectOnlyOne]="true"
    [showFilterInput]="true"
    (selectOneUserEvent)="changeOwner($event)"
    [usersSelected]="usersSelected"
    (usersSelectedChange)="usersSelected = $event"></ngx-users-search>
</div>
